import styled from 'styled-components'
import { fontSizeHeader, fontWeightBold } from 'Utils/styles/text'

export const ModalHeader = styled.div`
  margin: 0;
  font-size: ${fontSizeHeader};
  font-weight: ${fontWeightBold};
`
